import { useState, useEffect } from 'react';
import ProductService from '../service/ProductService';

export function useGetStock() {
  const [stockList, setStockList] = useState([]);

  useEffect(() => {
    ProductService.getAll()
      .then((response) => {
        console.log(response.data.data);
        setStockList(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    stockList,
    setStockList
  };
}
